// extracted by mini-css-extract-plugin
module.exports = {"more-icon":"DropdownButtonMore-module__more-icon__3jiS8"};